module.exports = function() {
  return new Worker(__webpack_public_path__ + "8f88b483c7150483a31c.worker.js");
};